import React, { useEffect } from "react";
import "../../css_files/Ticket/TicketInfo.css";
import axiosIntance from "../../api";
import CloseForm from "../Master/CloseForm";

function TicketInfo({ ticketId, setshowticketinfo, ticketinfodata }) {
  return (
    <section className="ticket-info">
      <div>
        <h1>Ticket Detail</h1>
        <p>
          <strong>Ticket Id: </strong>
          {ticketinfodata.seriesId}
        </p>
        <p>
          <strong>Linked to Enquiry: </strong>
          {ticketinfodata.enquirySeriesId}
        </p>
        <p>
          <strong>Service Type: </strong>
          {ticketinfodata.serviceDetails.serviceType}
        </p>
        <p>
          <strong>Enquiry Type: </strong>
          {ticketinfodata.enquiryType}
        </p>
        <p>
          <strong>
            {ticketinfodata.serviceDetails.enquiryType === "Service"
              ? "Services"
              : ticketinfodata.serviceDetails.enquiryType}{" "}
            Description:{" "}
          </strong>
          {ticketinfodata.serviceDetails.serviceDescription}
        </p>
        <p>
          <strong>Due Date: </strong>
          {ticketinfodata.serviceDetails.dueDate}
        </p>
        <p>
          <strong>Remarks: </strong>
          {ticketinfodata.serviceDetails.remarks}
        </p>
        <p>
          <strong>Status: </strong>
          {ticketinfodata.status}
        </p>
        <p>
          <strong>Quotation Sent: </strong>
          {ticketinfodata.isQuotationSent
            ? "Yes"
            : ticketinfodata.serviceDetails.serviceType === "FOC"
            ? "Not Applicable"
            : "No"}
        </p>
        <p>
          <strong>Order Created: </strong>
          {ticketinfodata.isOrderCreated
            ? "Yes"
            : ticketinfodata.serviceDetails.serviceType === "FOC"
            ? "Not Applicable"
            : "No"}
        </p>
        {ticketinfodata.serviceDetails.serviceType === "Paid" && (
          <>
            <p>
              <strong>Bill Amount: </strong>
              {ticketinfodata.symbol} {ticketinfodata.billAmount ?? "---"}
            </p>
            <p>
              <strong>Due Amount: </strong>
              {ticketinfodata.symbol} {ticketinfodata.dueAmount ?? "---"}
            </p>
          </>
        )}
        <CloseForm close={setshowticketinfo} />
      </div>
    </section>
  );
}

export default TicketInfo;
